import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domAttr from 'dojo/dom-attr';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import domConstructTyped from 'dojo/dom-construct';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import template from './RatingDialog.html?raw';
// NOTE (JS2TS): dropped dead dojo/dijit deps (connect, array, Color, keys, dijit
// _WidgetBase/_TemplatedMixin/_WidgetsInTemplateMixin, registry, mouse). DOM-heavy → dom-construct aliased.

const domConstruct: any = domConstructTyped;

class RatingDialog extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;
    callback: any = function () { };
    genericDialog: any = null;
    entity: any = null;
    selectedRating: any = null;
    comment: any = null;

    _headingAttribute = "ID";

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse

    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.placeAt(document.body);
    }

    _setEntityAttr(entity: any, valueAttribute: any, commentAttribute: any, headingAttribute?: any): void {
        this.entity = entity;

        this.selectedRating = entity[valueAttribute];
        this.comment = entity[commentAttribute];

        if (typeof (headingAttribute) != "undefined") {
            this._headingAttribute = headingAttribute;
        }

        console.log("rating dialog entity", this.entity, this.selectedRating, this.comment);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        var dialog: any = new GenericDialog();

        dialog.hideSubtitleNode();

        this.genericDialog = dialog;
        domStyle.set(dialog.textNode, "height", "unset");

        var value = this.selectedRating;//.getValue();
        this.selectedRating = value;

        this.drawRatingStars();

        var input = domConstruct.create("textarea");
        domClass.add(input, "w3-input w3-block");
        dialog.addNodeToContent(input);
        domAttr.set(input, "placeholder", this.translations["OccurrenceRating__DialogPlaceholderNotes"]);//"Anmerkungen?");

        if (this.comment != null && this.comment != "") {
            domAttr.set(input, "value", this.comment);
        }

        // verhinden dass mit "Enter" der Dialog beendet wird
        on(input, "keyup", function (evt: any) {
            evt.stopPropagation();
        });

        dialog.set("header", this.translations["OccurrenceRating__DialogHeading"].format(this.entity[this._headingAttribute]));
        //dialog.set("content", "Hier Freitexteingabe");
        dialog.set("callback", lang.hitch(this, "ratingDialogCallback", input));

        dialog.set("ok", true);
        dialog.set("cancel", true);

        dialog.show();
    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }

    ratingDialogCallback(input: any, result: any): void {

        this.comment = input.value;
        //console.log("ratingDialogCallback", input, result, this.selectedRating, "Anm: " + this.comment);

        if (result != 1) {
            this._onEndRating(result);
            return;
        }

        var dialog: any = new GenericDialog();
        dialog.hideSubtitleNode();
        this.genericDialog = dialog;
        domStyle.set(dialog.textNode, "height", "unset");
        dialog.set("header", this.translations["OccurrenceRating__DialogHeading"].format(this.entity[this._headingAttribute]));//"Bewertung");
        dialog.set("content", this.translations["OccurrenceRating__DialogSaveProgress"]);//"Bewertung wird gespeichert...")

        dialog.show();

        dialog.StandbyStart();

        this.updateRating();
    }

    selectRating(value: any, evt?: any): void {

        //// Ausnahme: 0 Sterne vergeben indem auf den 1er-Stern zweimal geklickt wird
        //if (this.selectedRating == 1 && value == 1) {
        //    value = 0;
        //}
        this.selectedRating = value;

        this.drawRatingStars();
    }

    drawRatingStars(): void {

        var dialog = this.genericDialog;

        domConstruct.empty(dialog.subTitleNode);

        var currentValue = this.selectedRating;

        for (var i = 1; i <= 5; i++) {
            var star = domConstruct.create("i");

            if (currentValue >= i) {
                domClass.add(star, "w3-xlarge w3-text-amber fa fa-star mds-text-hover-dark");
            } else {
                domClass.add(star, "w3-xlarge w3-text-amber fa fa-star-o mds-text-hover-dark");
            }

            dialog.addNodeToSubtitle(star);

            on(star, "click", lang.hitch(this, "selectRating", i));
        }
    }

    updateRating(): void {

        var entityId = this.entity.ID;
        var value = this.selectedRating;
        var text = this.comment;
        //console.log("save rating", entityIds, values);

        var url = window.appRoot + "JDM/SaveRating";

        this.RequestManager.post(
            url,
            {
                entityId: entityId,
                value: value,
                comment: text
            },
            lang.hitch(this, "_onSaveRatingResponse"),
            lang.hitch(this, "_onSaveRatingError"),
            false // sync
        );
    }

    _onSaveRatingResponse(response: any): void {
        this.genericDialog.StandbyEnd();
        var message = "<p>" + this.translations["OccurrenceRating__DialogSubmitResponse"] + "</p>";
        this.genericDialog.set("content", message); //"Vielen Dank für Ihre Bewertung.");

        this.genericDialog.set("callback", lang.hitch(this, "_onEndRating"));
        this.genericDialog.set("ok", true);
    }

    _onSaveRatingError(error: any): void {
        console.error("Bewertung konnte nicht gespeichert werden", error.Message);
        this.genericDialog.StandbyEnd();

        this.genericDialog.set("content", this.translations["OccurrenceRating__DialogSubmitResponseError"].format(error.Message));//Fehler beim Speichern: " + error.Message);
        this.genericDialog.set("cancel", true);
        // Benutzer irgendwie informieren??
        //alert(error.Message);
    }

    _onEndRating(result: any): void {
        this.removeUrlAction("rate");
        if (typeof (this.callback) == "function") {
            this.callback(result, this.selectedRating);
        }
    }

}
RatingDialog.prototype.declaredClass = 'WidgetCollection.JDM.Occurrence.RatingDialog.RatingDialog';

export default mdsWidget(RatingDialog);
